import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Radio } from './types'

export const RADIOS_QUERY: TypedDocumentNode<
  { radios: Radio[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Radios($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    radios(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id name stream_url listening_url observations unavailable_message old_id created_at updated_at
    }
  }
`

export const RADIO_QUERY: TypedDocumentNode<{ radio: Radio | null }, { id: string }> = gql`
  query Radio($id: ID!) {
    radio(id: $id) {
      id client_id application_id name stream_url listening_url observations unavailable_message old_id created_at updated_at
    }
  }
`
